"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreContextProvider = exports.CoreContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
/**
 * The actual context object.
 * @internal This should only be consumed internally. Try to avoid it if possible, if not, make sure the component don't crash if the values are not defined.
 * @example const domain = React.useContext(CoreContext)?.domain;
 */
exports.CoreContext = (0, react_1.createContext)({ domain: null });
/**
 * The goal of this context is to provide props, e. g domain information to internal components.
 * @internal The context is already provided in CoreMui5Provider along with the theme, so there should be no need to provide this seperately.
 */
const CoreContextProvider = ({ children, ...values }) => {
    return react_1.default.createElement(exports.CoreContext.Provider, { value: values }, children);
};
exports.CoreContextProvider = CoreContextProvider;
